const getLeadStatusNumber = (leadStatus) => {
    if (leadStatus === null || leadStatus === undefined || leadStatus === '') {
        return null;
    }

    const value = Number(leadStatus);
    return Number.isFinite(value) ? value : null;
};

export const isDirectWonLeadStatus = (leadStatus) => getLeadStatusNumber(leadStatus) === 8;

export const shouldAutofillProposalDateForLeadStatus = (leadStatus) => {
    const value = getLeadStatusNumber(leadStatus);
    return value !== null && value >= 5 && value < 8;
};

export const shouldRequireProposalDateForLeadStatus = (leadStatus) => {
    const value = getLeadStatusNumber(leadStatus);
    return value !== null && value >= 1 && value < 8;
};

export const shouldRequirePresentationDateForLeadStatus = (leadStatus, noPresentation = false) => {
    const value = getLeadStatusNumber(leadStatus);
    return value !== null && value >= 4 && value < 8 && !noPresentation;
};
